/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * MyYoast
 * The MyYoast Api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AcademyCourseAccessListDto,
  ActivateAccountDto,
  ActivateAccountResponseDto,
  CancelSubscriptionBodyDto,
  ChangePasswordDto,
  CreateAccountDto,
  CreateSiteBodyDto,
  Customer,
  CustomerProfileResponseDto,
  DownloadDto,
  GetAllBiennialEligibleParams,
  GetManyCustomerIdentitiesParams,
  GetManyCustomerLicensesParams,
  GetManyCustomerOrdersParams,
  GetManyCustomerSitesParams,
  GetManyCustomerSubscriptionsParams,
  GetManyCustomersParams,
  GetManyPagedCustomersParams,
  GetOneCustomerOrderParams,
  GetOneCustomerParams,
  GetOneCustomerSiteParams,
  GetOneCustomerSubscriptionParams,
  GetSubscriptionListParams,
  JSZip,
  LegacyPricingNoticeDto,
  License,
  Order,
  Refund,
  ResetPasswordDto,
  RoleIDDto,
  SendResetPasswordEmailDto,
  SignupAccountDto,
  Site,
  SiteAssignablePluginDto,
  SiteWithSubscriptionsDto,
  Subscription,
  SubscriptionDto,
  SubscriptionListResponseDto,
  SubscriptionSummaryDto,
  SuccessResponseDto,
  UnspecifiedResponseDto,
  UpcomingRenewalDto,
  UpdateUserDto,
  UpdateUserToWordpressDto,
  UserIdentity
} from '../models';

import { customFetch } from '../../customFetch';
import type { ErrorType } from '../../customFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCancelCustomerSubscriptionUrl = (customerId: string,
    id: string,) => {




  return `/api/Customers/${customerId}/subscriptions/${id}/cancel`
}

/**
 * Communicates a (partial) subscription to yoast.com.
 * @summary Cancel (part of) a subscription.
 */
export const cancelCustomerSubscription = async (customerId: string,
    id: string,
    cancelSubscriptionBodyDto: CancelSubscriptionBodyDto, options?: RequestInit): Promise<Subscription | Subscription[]> => {

  return customFetch<Subscription | Subscription[]>(getCancelCustomerSubscriptionUrl(customerId,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelSubscriptionBodyDto)
  }
);}




export const getCancelCustomerSubscriptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCustomerSubscription>>, TError,{customerId: string;id: string;data: CancelSubscriptionBodyDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelCustomerSubscription>>, TError,{customerId: string;id: string;data: CancelSubscriptionBodyDto}, TContext> => {

const mutationKey = ['cancelCustomerSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelCustomerSubscription>>, {customerId: string;id: string;data: CancelSubscriptionBodyDto}> = (props) => {
          const {customerId,id,data} = props ?? {};

          return  cancelCustomerSubscription(customerId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelCustomerSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelCustomerSubscription>>>
    export type CancelCustomerSubscriptionMutationBody = CancelSubscriptionBodyDto
    export type CancelCustomerSubscriptionMutationError = ErrorType<void>

    /**
 * @summary Cancel (part of) a subscription.
 */
export const useCancelCustomerSubscription = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelCustomerSubscription>>, TError,{customerId: string;id: string;data: CancelSubscriptionBodyDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelCustomerSubscription>>,
        TError,
        {customerId: string;id: string;data: CancelSubscriptionBodyDto},
        TContext
      > => {
      return useMutation(getCancelCustomerSubscriptionMutationOptions(options), queryClient);
    }
    export const getGetAllBiennialEligibleUrl = (customerId: string,
    params?: GetAllBiennialEligibleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/subscriptions/biennial-eligible?${stringifiedParams}` : `/api/Customers/${customerId}/subscriptions/biennial-eligible`
}

/**
 * Active, yearly subscriptions that can be switched to a two-year billing term.
 * @summary Get subscriptions eligible for biennial billing
 */
export const getAllBiennialEligible = async (customerId: string,
    params?: GetAllBiennialEligibleParams, options?: RequestInit): Promise<Subscription[]> => {

  return customFetch<Subscription[]>(getGetAllBiennialEligibleUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAllBiennialEligibleQueryKey = (customerId: string,
    params?: GetAllBiennialEligibleParams,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/biennial-eligible`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAllBiennialEligibleQueryOptions = <TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllBiennialEligibleQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllBiennialEligible>>> = ({ signal }) => getAllBiennialEligible(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllBiennialEligibleQueryResult = NonNullable<Awaited<ReturnType<typeof getAllBiennialEligible>>>
export type GetAllBiennialEligibleQueryError = ErrorType<void>


export function useGetAllBiennialEligible<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetAllBiennialEligibleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBiennialEligible>>,
          TError,
          Awaited<ReturnType<typeof getAllBiennialEligible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBiennialEligible<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllBiennialEligible>>,
          TError,
          Awaited<ReturnType<typeof getAllBiennialEligible>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBiennialEligible<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscriptions eligible for biennial billing
 */

export function useGetAllBiennialEligible<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllBiennialEligibleQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAllBiennialEligibleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllBiennialEligibleQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllBiennialEligible>>> = ({ signal }) => getAllBiennialEligible(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllBiennialEligibleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllBiennialEligible>>>
export type GetAllBiennialEligibleSuspenseQueryError = ErrorType<void>


export function useGetAllBiennialEligibleSuspense<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetAllBiennialEligibleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBiennialEligibleSuspense<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllBiennialEligibleSuspense<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscriptions eligible for biennial billing
 */

export function useGetAllBiennialEligibleSuspense<TData = Awaited<ReturnType<typeof getAllBiennialEligible>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetAllBiennialEligibleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllBiennialEligible>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllBiennialEligibleSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getEnableBiennialBillingUrl = (customerId: string,
    id: string,) => {




  return `/api/Customers/${customerId}/subscriptions/${id}/enable-biennial-billing`
}

/**
 * Switches every active subscription sharing this subscription number to a two-year billing term.
 * @summary Enable biennial billing
 */
export const enableBiennialBilling = async (customerId: string,
    id: string, options?: RequestInit): Promise<SuccessResponseDto> => {

  return customFetch<SuccessResponseDto>(getEnableBiennialBillingUrl(customerId,id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEnableBiennialBillingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableBiennialBilling>>, TError,{customerId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enableBiennialBilling>>, TError,{customerId: string;id: string}, TContext> => {

const mutationKey = ['enableBiennialBilling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableBiennialBilling>>, {customerId: string;id: string}> = (props) => {
          const {customerId,id} = props ?? {};

          return  enableBiennialBilling(customerId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableBiennialBillingMutationResult = NonNullable<Awaited<ReturnType<typeof enableBiennialBilling>>>

    export type EnableBiennialBillingMutationError = ErrorType<void>

    /**
 * @summary Enable biennial billing
 */
export const useEnableBiennialBilling = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableBiennialBilling>>, TError,{customerId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableBiennialBilling>>,
        TError,
        {customerId: string;id: string},
        TContext
      > => {
      return useMutation(getEnableBiennialBillingMutationOptions(options), queryClient);
    }
    export const getDisableBiennialBillingUrl = (customerId: string,
    id: string,) => {




  return `/api/Customers/${customerId}/subscriptions/${id}/disable-biennial-billing`
}

/**
 * Restores every active subscription sharing this subscription number to a yearly billing term.
 * @summary Disable biennial billing
 */
export const disableBiennialBilling = async (customerId: string,
    id: string, options?: RequestInit): Promise<SuccessResponseDto> => {

  return customFetch<SuccessResponseDto>(getDisableBiennialBillingUrl(customerId,id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDisableBiennialBillingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableBiennialBilling>>, TError,{customerId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableBiennialBilling>>, TError,{customerId: string;id: string}, TContext> => {

const mutationKey = ['disableBiennialBilling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableBiennialBilling>>, {customerId: string;id: string}> = (props) => {
          const {customerId,id} = props ?? {};

          return  disableBiennialBilling(customerId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableBiennialBillingMutationResult = NonNullable<Awaited<ReturnType<typeof disableBiennialBilling>>>

    export type DisableBiennialBillingMutationError = ErrorType<void>

    /**
 * @summary Disable biennial billing
 */
export const useDisableBiennialBilling = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableBiennialBilling>>, TError,{customerId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableBiennialBilling>>,
        TError,
        {customerId: string;id: string},
        TContext
      > => {
      return useMutation(getDisableBiennialBillingMutationOptions(options), queryClient);
    }
    export const getGetSubscriptionSummaryUrl = (customerId: string,) => {




  return `/api/Customers/${customerId}/subscriptions/summary`
}

/**
 * Account-wide aggregates over the customer's subscriptions, for the screens that only need a count or a boolean rather than the collection itself.
 * @summary Get subscription aggregates
 */
export const getSubscriptionSummary = async (customerId: string, options?: RequestInit): Promise<SubscriptionSummaryDto> => {

  return customFetch<SubscriptionSummaryDto>(getGetSubscriptionSummaryUrl(customerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionSummaryQueryKey = (customerId: string,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/summary`
    ] as const;
    }


export const getGetSubscriptionSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionSummaryQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionSummary>>> = ({ signal }) => getSubscriptionSummary(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionSummary>>>
export type GetSubscriptionSummaryQueryError = ErrorType<void>


export function useGetSubscriptionSummary<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionSummary>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSummary<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionSummary>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSummary<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscription aggregates
 */

export function useGetSubscriptionSummary<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionSummaryQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetSubscriptionSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionSummaryQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionSummary>>> = ({ signal }) => getSubscriptionSummary(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionSummary>>>
export type GetSubscriptionSummarySuspenseQueryError = ErrorType<void>


export function useGetSubscriptionSummarySuspense<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSummarySuspense<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionSummarySuspense<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscription aggregates
 */

export function useGetSubscriptionSummarySuspense<TData = Awaited<ReturnType<typeof getSubscriptionSummary>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionSummarySuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetLegacyPricingNoticeUrl = (customerId: string,) => {




  return `/api/Customers/${customerId}/subscriptions/legacy-pricing-notice`
}

/**
 * Whether the customer is one of those we were never able to reach about the packaging-and-pricing migration and who still hold an affected plan, for the notice legal requires MyYoast to carry. The banner's date window bounds the notice; customers whose SKU is switched by the migration also stop matching.
 * @summary Get the pricing-migration notice
 */
export const getLegacyPricingNotice = async (customerId: string, options?: RequestInit): Promise<LegacyPricingNoticeDto> => {

  return customFetch<LegacyPricingNoticeDto>(getGetLegacyPricingNoticeUrl(customerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLegacyPricingNoticeQueryKey = (customerId: string,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/legacy-pricing-notice`
    ] as const;
    }


export const getGetLegacyPricingNoticeQueryOptions = <TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLegacyPricingNoticeQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegacyPricingNotice>>> = ({ signal }) => getLegacyPricingNotice(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLegacyPricingNoticeQueryResult = NonNullable<Awaited<ReturnType<typeof getLegacyPricingNotice>>>
export type GetLegacyPricingNoticeQueryError = ErrorType<void>


export function useGetLegacyPricingNotice<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegacyPricingNotice>>,
          TError,
          Awaited<ReturnType<typeof getLegacyPricingNotice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegacyPricingNotice<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegacyPricingNotice>>,
          TError,
          Awaited<ReturnType<typeof getLegacyPricingNotice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegacyPricingNotice<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the pricing-migration notice
 */

export function useGetLegacyPricingNotice<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLegacyPricingNoticeQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetLegacyPricingNoticeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLegacyPricingNoticeQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegacyPricingNotice>>> = ({ signal }) => getLegacyPricingNotice(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLegacyPricingNoticeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLegacyPricingNotice>>>
export type GetLegacyPricingNoticeSuspenseQueryError = ErrorType<void>


export function useGetLegacyPricingNoticeSuspense<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegacyPricingNoticeSuspense<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegacyPricingNoticeSuspense<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the pricing-migration notice
 */

export function useGetLegacyPricingNoticeSuspense<TData = Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLegacyPricingNotice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLegacyPricingNoticeSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetUpcomingRenewalsUrl = (customerId: string,) => {




  return `/api/Customers/${customerId}/subscriptions/upcoming-renewals`
}

/**
 * The subscriptions expiring within a month that the customer has to renew by hand, for the renewal warning banner. Returns exactly the rows the summary's upcomingRenewalCount counts.
 * @summary Get upcoming manual renewals
 */
export const getUpcomingRenewals = async (customerId: string, options?: RequestInit): Promise<UpcomingRenewalDto[]> => {

  return customFetch<UpcomingRenewalDto[]>(getGetUpcomingRenewalsUrl(customerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpcomingRenewalsQueryKey = (customerId: string,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/upcoming-renewals`
    ] as const;
    }


export const getGetUpcomingRenewalsQueryOptions = <TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpcomingRenewalsQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingRenewals>>> = ({ signal }) => getUpcomingRenewals(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpcomingRenewalsQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingRenewals>>>
export type GetUpcomingRenewalsQueryError = ErrorType<void>


export function useGetUpcomingRenewals<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingRenewals>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpcomingRenewals<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpcomingRenewals>>,
          TError,
          Awaited<ReturnType<typeof getUpcomingRenewals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpcomingRenewals<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get upcoming manual renewals
 */

export function useGetUpcomingRenewals<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpcomingRenewalsQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetUpcomingRenewalsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpcomingRenewalsQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpcomingRenewals>>> = ({ signal }) => getUpcomingRenewals(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpcomingRenewalsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpcomingRenewals>>>
export type GetUpcomingRenewalsSuspenseQueryError = ErrorType<void>


export function useGetUpcomingRenewalsSuspense<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpcomingRenewalsSuspense<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpcomingRenewalsSuspense<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get upcoming manual renewals
 */

export function useGetUpcomingRenewalsSuspense<TData = Awaited<ReturnType<typeof getUpcomingRenewals>>, TError = ErrorType<void>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpcomingRenewals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpcomingRenewalsSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetSubscriptionListUrl = (customerId: string,
    params?: GetSubscriptionListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/subscriptions/list?${stringifiedParams}` : `/api/Customers/${customerId}/subscriptions/list`
}

/**
 * A page of the customer's subscriptions, with searching, filtering, sorting and the four-way bucket partition all applied server-side.
 * @summary Get the subscriptions overview
 */
export const getSubscriptionList = async (customerId: string,
    params?: GetSubscriptionListParams, options?: RequestInit): Promise<SubscriptionListResponseDto> => {

  return customFetch<SubscriptionListResponseDto>(getGetSubscriptionListUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionListQueryKey = (customerId: string,
    params?: GetSubscriptionListParams,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSubscriptionListQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionListQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionList>>> = ({ signal }) => getSubscriptionList(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionListQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionList>>>
export type GetSubscriptionListQueryError = ErrorType<void>


export function useGetSubscriptionList<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetSubscriptionListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionList>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionList<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionList>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionList<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the subscriptions overview
 */

export function useGetSubscriptionList<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionListQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetSubscriptionListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionListQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionList>>> = ({ signal }) => getSubscriptionList(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSubscriptionListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionList>>>
export type GetSubscriptionListSuspenseQueryError = ErrorType<void>


export function useGetSubscriptionListSuspense<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetSubscriptionListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionListSuspense<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSubscriptionListSuspense<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the subscriptions overview
 */

export function useGetSubscriptionListSuspense<TData = Awaited<ReturnType<typeof getSubscriptionList>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetSubscriptionListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSubscriptionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSubscriptionListSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerSubscriptionUrl = (customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/subscriptions/${id}?${stringifiedParams}` : `/api/Customers/${customerId}/subscriptions/${id}`
}

/**
 * Get a single subscriptions of a customer
 * @summary Get a subscriptions
 */
export const getOneCustomerSubscription = async (customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: RequestInit): Promise<Subscription> => {

  return customFetch<Subscription>(getGetOneCustomerSubscriptionUrl(customerId,id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneCustomerSubscriptionQueryKey = (customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams,) => {
    return [
    `/api/Customers/${customerId}/subscriptions/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOneCustomerSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerSubscriptionQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerSubscription>>> = ({ signal }) => getOneCustomerSubscription(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerSubscription>>>
export type GetOneCustomerSubscriptionQueryError = ErrorType<void>


export function useGetOneCustomerSubscription<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerSubscriptionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSubscription<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerSubscription>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerSubscription>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSubscription<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a subscriptions
 */

export function useGetOneCustomerSubscription<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerSubscriptionQueryOptions(customerId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerSubscriptionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerSubscriptionQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerSubscription>>> = ({ signal }) => getOneCustomerSubscription(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerSubscriptionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerSubscription>>>
export type GetOneCustomerSubscriptionSuspenseQueryError = ErrorType<void>


export function useGetOneCustomerSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerSubscriptionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a subscriptions
 */

export function useGetOneCustomerSubscriptionSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSubscriptionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSubscription>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerSubscriptionSuspenseQueryOptions(customerId,id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerSubscriptionsUrl = (customerId: string,
    params?: GetManyCustomerSubscriptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/subscriptions?${stringifiedParams}` : `/api/Customers/${customerId}/subscriptions`
}

/**
 * Get and filter subscriptions of a customer
 * @summary Get subscriptions
 */
export const getManyCustomerSubscriptions = async (customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: RequestInit): Promise<SubscriptionDto[]> => {

  return customFetch<SubscriptionDto[]>(getGetManyCustomerSubscriptionsUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerSubscriptionsQueryKey = (customerId: string,
    params?: GetManyCustomerSubscriptionsParams,) => {
    return [
    `/api/Customers/${customerId}/subscriptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomerSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerSubscriptionsQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>> = ({ signal }) => getManyCustomerSubscriptions(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>>
export type GetManyCustomerSubscriptionsQueryError = ErrorType<void>


export function useGetManyCustomerSubscriptions<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerSubscriptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSubscriptions<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSubscriptions<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscriptions
 */

export function useGetManyCustomerSubscriptions<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerSubscriptionsQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerSubscriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerSubscriptionsQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>> = ({ signal }) => getManyCustomerSubscriptions(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerSubscriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>>
export type GetManyCustomerSubscriptionsSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerSubscriptionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get subscriptions
 */

export function useGetManyCustomerSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSubscriptionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerSubscriptionsSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAssignableSubscriptionsUrl = (customerId: string,
    siteId: string,) => {




  return `/api/Customers/${customerId}/sites/${siteId}/assignable-subscriptions`
}

/**
 * One row per plugin, carrying account-wide activation slot totals together with whether the plugin is enabled on this particular site and whether the assignment may be changed from within MyYoast.
 * @summary Get the plugins assignable to a site
 */
export const getAssignableSubscriptions = async (customerId: string,
    siteId: string, options?: RequestInit): Promise<SiteAssignablePluginDto[]> => {

  return customFetch<SiteAssignablePluginDto[]>(getGetAssignableSubscriptionsUrl(customerId,siteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssignableSubscriptionsQueryKey = (customerId: string,
    siteId: string,) => {
    return [
    `/api/Customers/${customerId}/sites/${siteId}/assignable-subscriptions`
    ] as const;
    }


export const getGetAssignableSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(customerId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssignableSubscriptionsQueryKey(customerId,siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignableSubscriptions>>> = ({ signal }) => getAssignableSubscriptions(customerId,siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined && siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssignableSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAssignableSubscriptions>>>
export type GetAssignableSubscriptionsQueryError = ErrorType<void>


export function useGetAssignableSubscriptions<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignableSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAssignableSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignableSubscriptions<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssignableSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getAssignableSubscriptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignableSubscriptions<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the plugins assignable to a site
 */

export function useGetAssignableSubscriptions<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssignableSubscriptionsQueryOptions(customerId,siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAssignableSubscriptionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(customerId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssignableSubscriptionsQueryKey(customerId,siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssignableSubscriptions>>> = ({ signal }) => getAssignableSubscriptions(customerId,siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssignableSubscriptionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAssignableSubscriptions>>>
export type GetAssignableSubscriptionsSuspenseQueryError = ErrorType<void>


export function useGetAssignableSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignableSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssignableSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the plugins assignable to a site
 */

export function useGetAssignableSubscriptionsSuspense<TData = Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError = ErrorType<void>>(
 customerId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAssignableSubscriptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssignableSubscriptionsSuspenseQueryOptions(customerId,siteId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerSiteUrl = (customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/sites/${id}?${stringifiedParams}` : `/api/Customers/${customerId}/sites/${id}`
}

/**
 * Get a single site of a customer
 * @summary Get a site
 */
export const getOneCustomerSite = async (customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: RequestInit): Promise<SiteWithSubscriptionsDto> => {

  return customFetch<SiteWithSubscriptionsDto>(getGetOneCustomerSiteUrl(customerId,id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneCustomerSiteQueryKey = (customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams,) => {
    return [
    `/api/Customers/${customerId}/sites/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOneCustomerSiteQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerSiteQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerSite>>> = ({ signal }) => getOneCustomerSite(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerSiteQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerSite>>>
export type GetOneCustomerSiteQueryError = ErrorType<void>


export function useGetOneCustomerSite<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerSiteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerSite>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSite<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerSite>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerSite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSite<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site
 */

export function useGetOneCustomerSite<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerSiteQueryOptions(customerId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerSiteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerSiteQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerSite>>> = ({ signal }) => getOneCustomerSite(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerSiteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerSite>>>
export type GetOneCustomerSiteSuspenseQueryError = ErrorType<void>


export function useGetOneCustomerSiteSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerSiteParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSiteSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSiteSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site
 */

export function useGetOneCustomerSiteSuspense<TData = Awaited<ReturnType<typeof getOneCustomerSite>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerSiteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerSite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerSiteSuspenseQueryOptions(customerId,id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerSitesUrl = (customerId: string,
    params?: GetManyCustomerSitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/sites?${stringifiedParams}` : `/api/Customers/${customerId}/sites`
}

/**
 * Get and filter sites of a customer
 * @summary Get sites
 */
export const getManyCustomerSites = async (customerId: string,
    params?: GetManyCustomerSitesParams, options?: RequestInit): Promise<SiteWithSubscriptionsDto[]> => {

  return customFetch<SiteWithSubscriptionsDto[]>(getGetManyCustomerSitesUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerSitesQueryKey = (customerId: string,
    params?: GetManyCustomerSitesParams,) => {
    return [
    `/api/Customers/${customerId}/sites`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomerSitesQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerSitesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerSites>>> = ({ signal }) => getManyCustomerSites(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerSitesQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerSites>>>
export type GetManyCustomerSitesQueryError = ErrorType<void>


export function useGetManyCustomerSites<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerSitesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerSites>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSites<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerSites>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSites<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManyCustomerSites<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerSitesQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerSitesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerSitesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerSites>>> = ({ signal }) => getManyCustomerSites(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerSitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerSites>>>
export type GetManyCustomerSitesSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerSitesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerSitesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSitesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerSitesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sites
 */

export function useGetManyCustomerSitesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerSites>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerSitesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerSites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerSitesSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCreateSiteUrl = (customerId: string,) => {




  return `/api/Customers/${customerId}/sites`
}

/**
 * Create a site record so we can link a subscription to a site which is linked to a customer
 * @summary Create a site for a user
 */
export const createSite = async (customerId: string,
    createSiteBodyDto: CreateSiteBodyDto, options?: RequestInit): Promise<Site> => {

  return customFetch<Site>(getCreateSiteUrl(customerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSiteBodyDto)
  }
);}




export const getCreateSiteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSite>>, TError,{customerId: string;data: CreateSiteBodyDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSite>>, TError,{customerId: string;data: CreateSiteBodyDto}, TContext> => {

const mutationKey = ['createSite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSite>>, {customerId: string;data: CreateSiteBodyDto}> = (props) => {
          const {customerId,data} = props ?? {};

          return  createSite(customerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSiteMutationResult = NonNullable<Awaited<ReturnType<typeof createSite>>>
    export type CreateSiteMutationBody = CreateSiteBodyDto
    export type CreateSiteMutationError = ErrorType<void>

    /**
 * @summary Create a site for a user
 */
export const useCreateSite = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSite>>, TError,{customerId: string;data: CreateSiteBodyDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSite>>,
        TError,
        {customerId: string;data: CreateSiteBodyDto},
        TContext
      > => {
      return useMutation(getCreateSiteMutationOptions(options), queryClient);
    }
    export const getGetOneCustomerOrderUrl = (customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/orders/${id}?${stringifiedParams}` : `/api/Customers/${customerId}/orders/${id}`
}

/**
 * Get a single order of a customer
 * @summary Get a order
 */
export const getOneCustomerOrder = async (customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: RequestInit): Promise<Order> => {

  return customFetch<Order>(getGetOneCustomerOrderUrl(customerId,id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneCustomerOrderQueryKey = (customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams,) => {
    return [
    `/api/Customers/${customerId}/orders/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOneCustomerOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerOrderQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerOrder>>> = ({ signal }) => getOneCustomerOrder(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerOrder>>>
export type GetOneCustomerOrderQueryError = ErrorType<void>


export function useGetOneCustomerOrder<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerOrder>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerOrder<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomerOrder>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomerOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerOrder<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a order
 */

export function useGetOneCustomerOrder<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerOrderQueryOptions(customerId,id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerOrderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerOrderQueryKey(customerId,id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomerOrder>>> = ({ signal }) => getOneCustomerOrder(customerId,id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerOrderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomerOrder>>>
export type GetOneCustomerOrderSuspenseQueryError = ErrorType<void>


export function useGetOneCustomerOrderSuspense<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params: undefined |  GetOneCustomerOrderParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerOrderSuspense<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerOrderSuspense<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a order
 */

export function useGetOneCustomerOrderSuspense<TData = Awaited<ReturnType<typeof getOneCustomerOrder>>, TError = ErrorType<void>>(
 customerId: string,
    id: string,
    params?: GetOneCustomerOrderParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomerOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerOrderSuspenseQueryOptions(customerId,id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerOrdersUrl = (customerId: string,
    params?: GetManyCustomerOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/orders?${stringifiedParams}` : `/api/Customers/${customerId}/orders`
}

/**
 * Get and filter orders of a customer
 * @summary Get orders
 */
export const getManyCustomerOrders = async (customerId: string,
    params?: GetManyCustomerOrdersParams, options?: RequestInit): Promise<Order[]> => {

  return customFetch<Order[]>(getGetManyCustomerOrdersUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerOrdersQueryKey = (customerId: string,
    params?: GetManyCustomerOrdersParams,) => {
    return [
    `/api/Customers/${customerId}/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomerOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerOrdersQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerOrders>>> = ({ signal }) => getManyCustomerOrders(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerOrders>>>
export type GetManyCustomerOrdersQueryError = ErrorType<void>


export function useGetManyCustomerOrders<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerOrders>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerOrders<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerOrders>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerOrders<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get orders
 */

export function useGetManyCustomerOrders<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerOrdersQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerOrdersQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerOrders>>> = ({ signal }) => getManyCustomerOrders(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerOrders>>>
export type GetManyCustomerOrdersSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerOrdersSuspense<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerOrdersSuspense<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerOrdersSuspense<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get orders
 */

export function useGetManyCustomerOrdersSuspense<TData = Awaited<ReturnType<typeof getManyCustomerOrders>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerOrdersSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerRolesUrl = (id: string,) => {




  return `/api/Customers/${id}/roles`
}

export const getManyCustomerRoles = async (id: string, options?: RequestInit): Promise<unknown> => {

  return customFetch<unknown>(getGetManyCustomerRolesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerRolesQueryKey = (id: string,) => {
    return [
    `/api/Customers/${id}/roles`
    ] as const;
    }


export const getGetManyCustomerRolesQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerRolesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerRoles>>> = ({ signal }) => getManyCustomerRoles(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerRoles>>>
export type GetManyCustomerRolesQueryError = ErrorType<void>


export function useGetManyCustomerRoles<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerRoles>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerRoles<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerRoles>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerRoles<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetManyCustomerRoles<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerRolesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerRolesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerRolesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerRoles>>> = ({ signal }) => getManyCustomerRoles(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerRolesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerRoles>>>
export type GetManyCustomerRolesSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerRolesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerRolesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerRolesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetManyCustomerRolesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerRoles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerRolesSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteRoleUrl = (id: string,) => {




  return `/api/Customers/${id}/roleMapping`
}

export const deleteRole = async (id: string,
    roleIDDto: RoleIDDto, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteRoleUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleIDDto)
  }
);}




export const getDeleteRoleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string;data: RoleIDDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string;data: RoleIDDto}, TContext> => {

const mutationKey = ['deleteRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRole>>, {id: string;data: RoleIDDto}> = (props) => {
          const {id,data} = props ?? {};

          return  deleteRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>
    export type DeleteRoleMutationBody = RoleIDDto
    export type DeleteRoleMutationError = ErrorType<void>

    export const useDeleteRole = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string;data: RoleIDDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRole>>,
        TError,
        {id: string;data: RoleIDDto},
        TContext
      > => {
      return useMutation(getDeleteRoleMutationOptions(options), queryClient);
    }
    export const getAddRoleUrl = (id: string,) => {




  return `/api/Customers/${id}/roleMapping`
}

export const addRole = async (id: string,
    roleIDDto: RoleIDDto, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getAddRoleUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleIDDto)
  }
);}




export const getAddRoleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{id: string;data: RoleIDDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{id: string;data: RoleIDDto}, TContext> => {

const mutationKey = ['addRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addRole>>, {id: string;data: RoleIDDto}> = (props) => {
          const {id,data} = props ?? {};

          return  addRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddRoleMutationResult = NonNullable<Awaited<ReturnType<typeof addRole>>>
    export type AddRoleMutationBody = RoleIDDto
    export type AddRoleMutationError = ErrorType<void>

    export const useAddRole = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addRole>>, TError,{id: string;data: RoleIDDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addRole>>,
        TError,
        {id: string;data: RoleIDDto},
        TContext
      > => {
      return useMutation(getAddRoleMutationOptions(options), queryClient);
    }
    export const getGetManyCustomerIdentitiesUrl = (customerId: string,
    params?: GetManyCustomerIdentitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/identities?${stringifiedParams}` : `/api/Customers/${customerId}/identities`
}

/**
 * Get and filter user identities of a customer
 * @summary Get user identities
 */
export const getManyCustomerIdentities = async (customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: RequestInit): Promise<UserIdentity[]> => {

  return customFetch<UserIdentity[]>(getGetManyCustomerIdentitiesUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerIdentitiesQueryKey = (customerId: string,
    params?: GetManyCustomerIdentitiesParams,) => {
    return [
    `/api/Customers/${customerId}/identities`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomerIdentitiesQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerIdentitiesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerIdentities>>> = ({ signal }) => getManyCustomerIdentities(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerIdentitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerIdentities>>>
export type GetManyCustomerIdentitiesQueryError = ErrorType<void>


export function useGetManyCustomerIdentities<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerIdentitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerIdentities>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerIdentities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerIdentities<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerIdentities>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerIdentities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerIdentities<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user identities
 */

export function useGetManyCustomerIdentities<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerIdentitiesQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerIdentitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerIdentitiesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerIdentities>>> = ({ signal }) => getManyCustomerIdentities(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerIdentitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerIdentities>>>
export type GetManyCustomerIdentitiesSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerIdentitiesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerIdentitiesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerIdentitiesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerIdentitiesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user identities
 */

export function useGetManyCustomerIdentitiesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerIdentitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerIdentities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerIdentitiesSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindRefundsUrl = (id: string,) => {




  return `/api/Customers/${id}/findRefunds`
}

/**
 * Find the refunds for provided user id.
 * @summary Find refunds for user
 */
export const findRefunds = async (id: string, options?: RequestInit): Promise<Refund[]> => {

  return customFetch<Refund[]>(getFindRefundsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getFindRefundsQueryKey = (id: string,) => {
    return [
    `/api/Customers/${id}/findRefunds`
    ] as const;
    }


export const getFindRefundsQueryOptions = <TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindRefundsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findRefunds>>> = ({ signal }) => findRefunds(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindRefundsQueryResult = NonNullable<Awaited<ReturnType<typeof findRefunds>>>
export type FindRefundsQueryError = ErrorType<void>


export function useFindRefunds<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findRefunds>>,
          TError,
          Awaited<ReturnType<typeof findRefunds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindRefunds<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findRefunds>>,
          TError,
          Awaited<ReturnType<typeof findRefunds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindRefunds<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find refunds for user
 */

export function useFindRefunds<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindRefundsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindRefundsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindRefundsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findRefunds>>> = ({ signal }) => findRefunds(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindRefundsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findRefunds>>>
export type FindRefundsSuspenseQueryError = ErrorType<void>


export function useFindRefundsSuspense<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindRefundsSuspense<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindRefundsSuspense<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find refunds for user
 */

export function useFindRefundsSuspense<TData = Awaited<ReturnType<typeof findRefunds>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findRefunds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindRefundsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getSignupUrl = () => {




  return `/api/Customers/signup`
}

/**
 * Using this route, a new account can be created on yoast.com
 * @summary Signup a customer on yoast.com following the normal signup flow.
 */
export const signup = async (signupAccountDto: SignupAccountDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupAccountDto)
  }
);}




export const getSignupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupAccountDto}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: SignupAccountDto}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = SignupAccountDto
    export type SignupMutationError = ErrorType<void>

    /**
 * @summary Signup a customer on yoast.com following the normal signup flow.
 */
export const useSignup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: SignupAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: SignupAccountDto},
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options), queryClient);
    }
    export const getCreateAccountUrl = () => {




  return `/api/Customers/create-account`
}

/**
 * Using this route, a new account can be created on yoast.com. The customer will receive a set-password mail.
 * @summary Creates an account for a customer on yoast.com without the signup flow.
 */
export const createAccount = async (createAccountDto: CreateAccountDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getCreateAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAccountDto)
  }
);}




export const getCreateAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountDto}, TContext> => {

const mutationKey = ['createAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccount>>, {data: CreateAccountDto}> = (props) => {
          const {data} = props ?? {};

          return  createAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createAccount>>>
    export type CreateAccountMutationBody = CreateAccountDto
    export type CreateAccountMutationError = ErrorType<void>

    /**
 * @summary Creates an account for a customer on yoast.com without the signup flow.
 */
export const useCreateAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccount>>, TError,{data: CreateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccount>>,
        TError,
        {data: CreateAccountDto},
        TContext
      > => {
      return useMutation(getCreateAccountMutationOptions(options), queryClient);
    }
    export const getActivateUrl = () => {




  return `/api/Customers/activate`
}

/**
 * This route can be used to activate the account of a new user.
 * @summary Activate the account of a user
 */
export const activate = async (activateAccountDto: ActivateAccountDto, options?: RequestInit): Promise<ActivateAccountResponseDto> => {

  return customFetch<ActivateAccountResponseDto>(getActivateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateAccountDto)
  }
);}




export const getActivateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateAccountDto}, TContext> => {

const mutationKey = ['activate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activate>>, {data: ActivateAccountDto}> = (props) => {
          const {data} = props ?? {};

          return  activate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateMutationResult = NonNullable<Awaited<ReturnType<typeof activate>>>
    export type ActivateMutationBody = ActivateAccountDto
    export type ActivateMutationError = ErrorType<void>

    /**
 * @summary Activate the account of a user
 */
export const useActivate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{data: ActivateAccountDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activate>>,
        TError,
        {data: ActivateAccountDto},
        TContext
      > => {
      return useMutation(getActivateMutationOptions(options), queryClient);
    }
    export const getSendResetPasswordEmailUrl = () => {




  return `/api/Customers/sendResetPasswordEmail`
}

/**
 * Use yoast.com to send a password reset email to the user email specified in the request body.
 * @summary Send a reset password email to the user.
 */
export const sendResetPasswordEmail = async (sendResetPasswordEmailDto: SendResetPasswordEmailDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getSendResetPasswordEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sendResetPasswordEmailDto)
  }
);}




export const getSendResetPasswordEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendResetPasswordEmail>>, TError,{data: SendResetPasswordEmailDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendResetPasswordEmail>>, TError,{data: SendResetPasswordEmailDto}, TContext> => {

const mutationKey = ['sendResetPasswordEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendResetPasswordEmail>>, {data: SendResetPasswordEmailDto}> = (props) => {
          const {data} = props ?? {};

          return  sendResetPasswordEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendResetPasswordEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendResetPasswordEmail>>>
    export type SendResetPasswordEmailMutationBody = SendResetPasswordEmailDto
    export type SendResetPasswordEmailMutationError = ErrorType<void>

    /**
 * @summary Send a reset password email to the user.
 */
export const useSendResetPasswordEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendResetPasswordEmail>>, TError,{data: SendResetPasswordEmailDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendResetPasswordEmail>>,
        TError,
        {data: SendResetPasswordEmailDto},
        TContext
      > => {
      return useMutation(getSendResetPasswordEmailMutationOptions(options), queryClient);
    }
    export const getResetPasswordUrl = () => {




  return `/api/Customers/resetPassword`
}

/**
 * This route allows a user to reset its password.
 * @summary Reset the user's password.
 */
export const resetPassword = async (resetPasswordDto: ResetPasswordDto, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getResetPasswordUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordDto)
  }
);}




export const getResetPasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordDto}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordDto
    export type ResetPasswordMutationError = ErrorType<void>

    /**
 * @summary Reset the user's password.
 */
export const useResetPassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordDto},
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }
    export const getChangePasswordUrl = (id: string,) => {




  return `/api/Customers/${id}/password`
}

/**
 * This route allows a customer to updates their password on WordPress.
 * @summary Update a customer's password in WordPress
 */
export const changePassword = async (id: string,
    changePasswordDto: ChangePasswordDto, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getChangePasswordUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordDto)
  }
);}




export const getChangePasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{id: string;data: ChangePasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{id: string;data: ChangePasswordDto}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {id: string;data: ChangePasswordDto}> = (props) => {
          const {id,data} = props ?? {};

          return  changePassword(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordDto
    export type ChangePasswordMutationError = ErrorType<void>

    /**
 * @summary Update a customer's password in WordPress
 */
export const useChangePassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{id: string;data: ChangePasswordDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {id: string;data: ChangePasswordDto},
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }
    export const getCreateAccessTokenUrl = (id: string,) => {




  return `/api/Customers/${id}/accessTokens`
}

/**
 * @summary Create an access token for a user
 */
export const createAccessToken = async (id: string, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getCreateAccessTokenUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateAccessTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{id: string}, TContext> => {

const mutationKey = ['createAccessToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessToken>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  createAccessToken(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessToken>>>

    export type CreateAccessTokenMutationError = ErrorType<unknown>

    /**
 * @summary Create an access token for a user
 */
export const useCreateAccessToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessToken>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAccessToken>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCreateAccessTokenMutationOptions(options), queryClient);
    }
    export const getGetAllRolesUrl = () => {




  return `/api/Customers/allroles`
}

/**
 * @summary Get all existing roles with their ID.
 */
export const getAllRoles = async ( options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getGetAllRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAllRolesQueryKey = () => {
    return [
    `/api/Customers/allroles`
    ] as const;
    }


export const getGetAllRolesQueryOptions = <TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRoles>>> = ({ signal }) => getAllRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRoles>>>
export type GetAllRolesQueryError = ErrorType<void>


export function useGetAllRoles<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRoles>>,
          TError,
          Awaited<ReturnType<typeof getAllRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRoles<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllRoles>>,
          TError,
          Awaited<ReturnType<typeof getAllRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRoles<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all existing roles with their ID.
 */

export function useGetAllRoles<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAllRolesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllRoles>>> = ({ signal }) => getAllRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllRolesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAllRoles>>>
export type GetAllRolesSuspenseQueryError = ErrorType<void>


export function useGetAllRolesSuspense<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRolesSuspense<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllRolesSuspense<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all existing roles with their ID.
 */

export function useGetAllRolesSuspense<TData = Awaited<ReturnType<typeof getAllRoles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAllRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllRolesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCustomersWithRoleUrl = () => {




  return `/api/Customers/rolemapping-ids`
}

/**
 * Requires the caller to have the admin role.
 * @summary Get the ids of all customers with at least one role.
 */
export const getCustomersWithRole = async ( options?: RequestInit): Promise<string[]> => {

  return customFetch<string[]>(getGetCustomersWithRoleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomersWithRoleQueryKey = () => {
    return [
    `/api/Customers/rolemapping-ids`
    ] as const;
    }


export const getGetCustomersWithRoleQueryOptions = <TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersWithRoleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersWithRole>>> = ({ signal }) => getCustomersWithRole({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersWithRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomersWithRole>>>
export type GetCustomersWithRoleQueryError = ErrorType<void>


export function useGetCustomersWithRole<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersWithRole>>,
          TError,
          Awaited<ReturnType<typeof getCustomersWithRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersWithRole<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersWithRole>>,
          TError,
          Awaited<ReturnType<typeof getCustomersWithRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersWithRole<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the ids of all customers with at least one role.
 */

export function useGetCustomersWithRole<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersWithRoleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCustomersWithRoleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersWithRoleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersWithRole>>> = ({ signal }) => getCustomersWithRole({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersWithRoleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomersWithRole>>>
export type GetCustomersWithRoleSuspenseQueryError = ErrorType<void>


export function useGetCustomersWithRoleSuspense<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersWithRoleSuspense<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersWithRoleSuspense<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the ids of all customers with at least one role.
 */

export function useGetCustomersWithRoleSuspense<TData = Awaited<ReturnType<typeof getCustomersWithRole>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCustomersWithRole>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersWithRoleSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentCustomerUrl = () => {




  return `/api/Customers/current`
}

/**
 * @summary Get the current customer
 */
export const currentCustomer = async ( options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getCurrentCustomerUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCurrentCustomerQueryKey = () => {
    return [
    `/api/Customers/current`
    ] as const;
    }


export const getCurrentCustomerQueryOptions = <TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentCustomerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentCustomer>>> = ({ signal }) => currentCustomer({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof currentCustomer>>>
export type CurrentCustomerQueryError = ErrorType<void>


export function useCurrentCustomer<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentCustomer>>,
          TError,
          Awaited<ReturnType<typeof currentCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCustomer<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof currentCustomer>>,
          TError,
          Awaited<ReturnType<typeof currentCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCustomer<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current customer
 */

export function useCurrentCustomer<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentCustomerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getCurrentCustomerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCurrentCustomerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof currentCustomer>>> = ({ signal }) => currentCustomer({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CurrentCustomerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof currentCustomer>>>
export type CurrentCustomerSuspenseQueryError = ErrorType<void>


export function useCurrentCustomerSuspense<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCustomerSuspense<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCurrentCustomerSuspense<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current customer
 */

export function useCurrentCustomerSuspense<TData = Awaited<ReturnType<typeof currentCustomer>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof currentCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCurrentCustomerSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyPagedCustomersUrl = (params?: GetManyPagedCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/paged?${stringifiedParams}` : `/api/Customers/paged`
}

/**
 * Get and filter customer
 * @summary Get customers
 */
export const getManyPagedCustomers = async (params?: GetManyPagedCustomersParams, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getGetManyPagedCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyPagedCustomersQueryKey = (params?: GetManyPagedCustomersParams,) => {
    return [
    `/api/Customers/paged`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyPagedCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyPagedCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyPagedCustomers>>> = ({ signal }) => getManyPagedCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyPagedCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getManyPagedCustomers>>>
export type GetManyPagedCustomersQueryError = ErrorType<unknown>


export function useGetManyPagedCustomers<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetManyPagedCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyPagedCustomers>>,
          TError,
          Awaited<ReturnType<typeof getManyPagedCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedCustomers<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyPagedCustomers>>,
          TError,
          Awaited<ReturnType<typeof getManyPagedCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedCustomers<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customers
 */

export function useGetManyPagedCustomers<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyPagedCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyPagedCustomersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyPagedCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyPagedCustomers>>> = ({ signal }) => getManyPagedCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyPagedCustomersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyPagedCustomers>>>
export type GetManyPagedCustomersSuspenseQueryError = ErrorType<unknown>


export function useGetManyPagedCustomersSuspense<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetManyPagedCustomersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedCustomersSuspense<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyPagedCustomersSuspense<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customers
 */

export function useGetManyPagedCustomersSuspense<TData = Awaited<ReturnType<typeof getManyPagedCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyPagedCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyPagedCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyPagedCustomersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getEnableUrl = (id: string,) => {




  return `/api/Customers/${id}/enable`
}

/**
 * Used when customers accidentally disable their own account
 * @summary Enables the customer with the given ID
 */
export const enable = async (id: string, options?: RequestInit): Promise<UnspecifiedResponseDto> => {

  return customFetch<UnspecifiedResponseDto>(getEnableUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEnableMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{id: string}, TContext> => {

const mutationKey = ['enable'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enable>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  enable(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableMutationResult = NonNullable<Awaited<ReturnType<typeof enable>>>

    export type EnableMutationError = ErrorType<void>

    /**
 * @summary Enables the customer with the given ID
 */
export const useEnable = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enable>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enable>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEnableMutationOptions(options), queryClient);
    }
    export const getDownloadProfileUrl = (id: string,) => {




  return `/api/Customers/${id}/download`
}

/**
 * Downloads the data of the given customer as CSV files inside a ZIP file.
 * @summary Download profile.
 */
export const downloadProfile = async (id: string, options?: RequestInit): Promise<JSZip> => {

  return customFetch<JSZip>(getDownloadProfileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadProfileQueryKey = (id: string,) => {
    return [
    `/api/Customers/${id}/download`
    ] as const;
    }


export const getDownloadProfileQueryOptions = <TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadProfile>>> = ({ signal }) => downloadProfile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadProfileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadProfile>>>
export type DownloadProfileQueryError = ErrorType<void>


export function useDownloadProfile<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadProfile>>,
          TError,
          Awaited<ReturnType<typeof downloadProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProfile<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadProfile>>,
          TError,
          Awaited<ReturnType<typeof downloadProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProfile<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download profile.
 */

export function useDownloadProfile<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadProfileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDownloadProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadProfile>>> = ({ signal }) => downloadProfile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof downloadProfile>>>
export type DownloadProfileSuspenseQueryError = ErrorType<void>


export function useDownloadProfileSuspense<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProfileSuspense<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadProfileSuspense<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download profile.
 */

export function useDownloadProfileSuspense<TData = Awaited<ReturnType<typeof downloadProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadProfileSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getProfileUrl = (id: string,) => {




  return `/api/Customers/${id}/profile`
}

/**
 * Returns the profile of the customer with the given ID, including support eligibility flags.
 * @summary Get a customer's profile
 */
export const profile = async (id: string, options?: RequestInit): Promise<CustomerProfileResponseDto> => {

  return customFetch<CustomerProfileResponseDto>(getProfileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProfileQueryKey = (id: string,) => {
    return [
    `/api/Customers/${id}/profile`
    ] as const;
    }


export const getProfileQueryOptions = <TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof profile>>> = ({ signal }) => profile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfileQueryResult = NonNullable<Awaited<ReturnType<typeof profile>>>
export type ProfileQueryError = ErrorType<void>


export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile>>,
          TError,
          Awaited<ReturnType<typeof profile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profile>>,
          TError,
          Awaited<ReturnType<typeof profile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a customer's profile
 */

export function useProfile<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof profile>>> = ({ signal }) => profile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof profile>>>
export type ProfileSuspenseQueryError = ErrorType<void>


export function useProfileSuspense<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfileSuspense<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfileSuspense<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a customer's profile
 */

export function useProfileSuspense<TData = Awaited<ReturnType<typeof profile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof profile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfileSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPatchProfileUrl = (id: string,) => {




  return `/api/Customers/${id}/profile`
}

/**
 * This route allows a customer to updates their profile on WordPress.
 * @summary Update a customer to WordPress
 */
export const patchProfile = async (id: string,
    updateUserToWordpressDto: UpdateUserToWordpressDto, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getPatchProfileUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserToWordpressDto)
  }
);}




export const getPatchProfileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProfile>>, TError,{id: string;data: UpdateUserToWordpressDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchProfile>>, TError,{id: string;data: UpdateUserToWordpressDto}, TContext> => {

const mutationKey = ['patchProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProfile>>, {id: string;data: UpdateUserToWordpressDto}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProfile(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchProfileMutationResult = NonNullable<Awaited<ReturnType<typeof patchProfile>>>
    export type PatchProfileMutationBody = UpdateUserToWordpressDto
    export type PatchProfileMutationError = ErrorType<void>

    /**
 * @summary Update a customer to WordPress
 */
export const usePatchProfile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProfile>>, TError,{id: string;data: UpdateUserToWordpressDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProfile>>,
        TError,
        {id: string;data: UpdateUserToWordpressDto},
        TContext
      > => {
      return useMutation(getPatchProfileMutationOptions(options), queryClient);
    }
    export const getUpdateOneCustomerUrl = (id: string,) => {




  return `/api/Customers/${id}`
}

export const updateOneCustomer = async (id: string,
    updateUserDto: UpdateUserDto, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getUpdateOneCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateUserDto)
  }
);}




export const getUpdateOneCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneCustomer>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOneCustomer>>, TError,{id: string;data: UpdateUserDto}, TContext> => {

const mutationKey = ['updateOneCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOneCustomer>>, {id: string;data: UpdateUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOneCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOneCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateOneCustomer>>>
    export type UpdateOneCustomerMutationBody = UpdateUserDto
    export type UpdateOneCustomerMutationError = ErrorType<unknown>

    export const useUpdateOneCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOneCustomer>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOneCustomer>>,
        TError,
        {id: string;data: UpdateUserDto},
        TContext
      > => {
      return useMutation(getUpdateOneCustomerMutationOptions(options), queryClient);
    }
    export const getGetOneCustomerUrl = (id: string,
    params?: GetOneCustomerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${id}?${stringifiedParams}` : `/api/Customers/${id}`
}

/**
 * Get a single customer
 * @summary Get a customer
 */
export const getOneCustomer = async (id: string,
    params?: GetOneCustomerParams, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getGetOneCustomerUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOneCustomerQueryKey = (id: string,
    params?: GetOneCustomerParams,) => {
    return [
    `/api/Customers/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOneCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomer>>> = ({ signal }) => getOneCustomer(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomer>>>
export type GetOneCustomerQueryError = ErrorType<unknown>


export function useGetOneCustomer<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetOneCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomer>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomer<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOneCustomer>>,
          TError,
          Awaited<ReturnType<typeof getOneCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomer<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a customer
 */

export function useGetOneCustomer<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetOneCustomerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOneCustomerQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOneCustomer>>> = ({ signal }) => getOneCustomer(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOneCustomerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOneCustomer>>>
export type GetOneCustomerSuspenseQueryError = ErrorType<unknown>


export function useGetOneCustomerSuspense<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params: undefined |  GetOneCustomerParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSuspense<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOneCustomerSuspense<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a customer
 */

export function useGetOneCustomerSuspense<TData = Awaited<ReturnType<typeof getOneCustomer>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetOneCustomerParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOneCustomer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOneCustomerSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomersUrl = (params?: GetManyCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers?${stringifiedParams}` : `/api/Customers`
}

/**
 * Get and filter customers
 * @summary Get customers
 */
export const getManyCustomers = async (params?: GetManyCustomersParams, options?: RequestInit): Promise<Customer[]> => {

  return customFetch<Customer[]>(getGetManyCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomersQueryKey = (params?: GetManyCustomersParams,) => {
    return [
    `/api/Customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(params?: GetManyCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomers>>> = ({ signal }) => getManyCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomers>>>
export type GetManyCustomersQueryError = ErrorType<unknown>


export function useGetManyCustomers<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetManyCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomers>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomers<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomers>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomers<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customers
 */

export function useGetManyCustomers<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(params?: GetManyCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomers>>> = ({ signal }) => getManyCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomers>>>
export type GetManyCustomersSuspenseQueryError = ErrorType<unknown>


export function useGetManyCustomersSuspense<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetManyCustomersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomersSuspense<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomersSuspense<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customers
 */

export function useGetManyCustomersSuspense<TData = Awaited<ReturnType<typeof getManyCustomers>>, TError = ErrorType<unknown>>(
 params?: GetManyCustomersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCourseAccessListUrl = (sourceId: number,) => {




  return `/api/Customers/academyCourseAccessList/${sourceId}`
}

/**
 * A list of Course IDs the customer has access to. Alongside some data in the case of shopify.
 * @summary Academy Course access
 */
export const getCourseAccessList = async (sourceId: number, options?: RequestInit): Promise<AcademyCourseAccessListDto> => {

  return customFetch<AcademyCourseAccessListDto>(getGetCourseAccessListUrl(sourceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCourseAccessListQueryKey = (sourceId: number,) => {
    return [
    `/api/Customers/academyCourseAccessList/${sourceId}`
    ] as const;
    }


export const getGetCourseAccessListQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(sourceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAccessListQueryKey(sourceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAccessList>>> = ({ signal }) => getCourseAccessList(sourceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sourceId !== null && sourceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCourseAccessListQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAccessList>>>
export type GetCourseAccessListQueryError = ErrorType<unknown>


export function useGetCourseAccessList<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseAccessList>>,
          TError,
          Awaited<ReturnType<typeof getCourseAccessList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessList<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseAccessList>>,
          TError,
          Awaited<ReturnType<typeof getCourseAccessList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessList<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Academy Course access
 */

export function useGetCourseAccessList<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseAccessListQueryOptions(sourceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCourseAccessListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(sourceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAccessListQueryKey(sourceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAccessList>>> = ({ signal }) => getCourseAccessList(sourceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCourseAccessListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAccessList>>>
export type GetCourseAccessListSuspenseQueryError = ErrorType<unknown>


export function useGetCourseAccessListSuspense<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListSuspense<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListSuspense<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Academy Course access
 */

export function useGetCourseAccessListSuspense<TData = Awaited<ReturnType<typeof getCourseAccessList>>, TError = ErrorType<unknown>>(
 sourceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseAccessListSuspenseQueryOptions(sourceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCourseAccessListByCustomerIdUrl = (customerId: string,) => {




  return `/api/Customers/academyCourseAccessListByCustomerId/${customerId}`
}

/**
 * A list of Course IDs the customer has access to. Alongside some data in the case of shopify.
 * @summary Academy Course access
 */
export const getCourseAccessListByCustomerId = async (customerId: string, options?: RequestInit): Promise<AcademyCourseAccessListDto> => {

  return customFetch<AcademyCourseAccessListDto>(getGetCourseAccessListByCustomerIdUrl(customerId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCourseAccessListByCustomerIdQueryKey = (customerId: string,) => {
    return [
    `/api/Customers/academyCourseAccessListByCustomerId/${customerId}`
    ] as const;
    }


export const getGetCourseAccessListByCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAccessListByCustomerIdQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>> = ({ signal }) => getCourseAccessListByCustomerId(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCourseAccessListByCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>>
export type GetCourseAccessListByCustomerIdQueryError = ErrorType<unknown>


export function useGetCourseAccessListByCustomerId<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListByCustomerId<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListByCustomerId<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Academy Course access
 */

export function useGetCourseAccessListByCustomerId<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseAccessListByCustomerIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetCourseAccessListByCustomerIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseAccessListByCustomerIdQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>> = ({ signal }) => getCourseAccessListByCustomerId(customerId, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCourseAccessListByCustomerIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>>
export type GetCourseAccessListByCustomerIdSuspenseQueryError = ErrorType<unknown>


export function useGetCourseAccessListByCustomerIdSuspense<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListByCustomerIdSuspense<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseAccessListByCustomerIdSuspense<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Academy Course access
 */

export function useGetCourseAccessListByCustomerIdSuspense<TData = Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError = ErrorType<unknown>>(
 customerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCourseAccessListByCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseAccessListByCustomerIdSuspenseQueryOptions(customerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAllUrl = (id: string,) => {




  return `/api/Customers/${id}/downloads`
}

/**
 * Gets all latest downloadable releases for products the customer has access to.
 * @summary Get all latest downloadable releases
 */
export const getAll = async (id: string, options?: RequestInit): Promise<DownloadDto[]> => {

  return customFetch<DownloadDto[]>(getGetAllUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAllQueryKey = (id: string,) => {
    return [
    `/api/Customers/${id}/downloads`
    ] as const;
    }


export const getGetAllQueryOptions = <TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAll>>> = ({ signal }) => getAll(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllQueryResult = NonNullable<Awaited<ReturnType<typeof getAll>>>
export type GetAllQueryError = ErrorType<void>


export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAll>>,
          TError,
          Awaited<ReturnType<typeof getAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAll>>,
          TError,
          Awaited<ReturnType<typeof getAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all latest downloadable releases
 */

export function useGetAll<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAll>>> = ({ signal }) => getAll(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAll>>>
export type GetAllSuspenseQueryError = ErrorType<void>


export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all latest downloadable releases
 */

export function useGetAllSuspense<TData = Awaited<ReturnType<typeof getAll>>, TError = ErrorType<void>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAllSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerLicensesUrl = (customerId: string,
    params?: GetManyCustomerLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Customers/${customerId}/licenses?${stringifiedParams}` : `/api/Customers/${customerId}/licenses`
}

/**
 * Get and filter licenses of a customer
 * @summary Get licenses
 */
export const getManyCustomerLicenses = async (customerId: string,
    params?: GetManyCustomerLicensesParams, options?: RequestInit): Promise<License[]> => {

  return customFetch<License[]>(getGetManyCustomerLicensesUrl(customerId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManyCustomerLicensesQueryKey = (customerId: string,
    params?: GetManyCustomerLicensesParams,) => {
    return [
    `/api/Customers/${customerId}/licenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManyCustomerLicensesQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerLicensesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerLicenses>>> = ({ signal }) => getManyCustomerLicenses(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerLicenses>>>
export type GetManyCustomerLicensesQueryError = ErrorType<void>


export function useGetManyCustomerLicenses<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerLicensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerLicenses>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerLicenses<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManyCustomerLicenses>>,
          TError,
          Awaited<ReturnType<typeof getManyCustomerLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerLicenses<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get licenses
 */

export function useGetManyCustomerLicenses<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerLicensesQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetManyCustomerLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManyCustomerLicensesQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManyCustomerLicenses>>> = ({ signal }) => getManyCustomerLicenses(customerId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetManyCustomerLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getManyCustomerLicenses>>>
export type GetManyCustomerLicensesSuspenseQueryError = ErrorType<void>


export function useGetManyCustomerLicensesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params: undefined |  GetManyCustomerLicensesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerLicensesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetManyCustomerLicensesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get licenses
 */

export function useGetManyCustomerLicensesSuspense<TData = Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError = ErrorType<void>>(
 customerId: string,
    params?: GetManyCustomerLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getManyCustomerLicenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetManyCustomerLicensesSuspenseQueryOptions(customerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteCustomerUrl = (id: string,) => {




  return `/api/Customers/${id}/gdpr-delete`
}

/**
 * Deletes and/or obfuscates all data related to a customer, except order data that we legally need to generate invoices.
 * @summary Performs a "GDPR forget me" request.
 */
export const deleteCustomer = async (id: string, options?: RequestInit): Promise<string> => {

  return customFetch<string>(getDeleteCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>

    export type DeleteCustomerMutationError = ErrorType<void>

    /**
 * @summary Performs a "GDPR forget me" request.
 */
export const useDeleteCustomer = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteCustomerMutationOptions(options), queryClient);
    }
